import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AppointmentRecord } from "@/lib/types/appointment";
import { saveAppointmentRecord } from "@/lib/services/appointmentModalService";
import { dayReportKey } from "@/hooks/company/useDayReport";
import { salonNow } from "@/lib/time";

/**
 * Custom React Query mutation hook for saving an appointment record.
 * Usage: const { mutate, isLoading, isError, isSuccess, error } = useSaveAppointmentModalRecord();
 */
export function useSaveAppointmentModalRecord() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (appointment: AppointmentRecord) => saveAppointmentRecord(appointment),
    onSuccess: (_data, vars) => {
      // Determine the correct date for the day-report invalidation:
      // • use the record's own date if provided
      // • otherwise fall back to “salon today”
      const date = (vars as AppointmentRecord | undefined)?.date ?? salonNow().toISODate();
      if (date) queryClient.invalidateQueries({ queryKey: dayReportKey(date) });
    },
  });
}
